module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excel-up"
  }, [_c('input', {
    ref: "excel-upload-input",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-043ec6b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/excelRead/excel.vue
// module id = 1678
// module chunks = 1